export const DELETE_ASSET_REQUEST = '@assets/DELETE_ASSET_REQUEST';
export const DELETE_ASSET_SUCCESS = '@assets/DELETE_ASSET_SUCCESS';
export const DELETE_ASSET_ERROR = '@assets/DELETE_ASSET_ERROR';
